

const initialState = {
  editingDriver: {},
};

const editDriver= (state = initialState, action) => {
  switch (action.type) {
    case "EDIT_DRIVER":
      return {
        ...state,
        editingDriver: action.data,
      };

    default:
      return state;
  }
};
export default editDriver